<template>
    <section class="serviceRange" >
        <header-com/>


        <div class="scrollWrap" :style="{'height':height}">
            <div class="backWrap">
                <img src="/images/home/serviceRange_01.png"  align="middle"/>
                <div class="inner">
                    <img src="/images/home/logo.png" alt="">
                    <h2 class=" bold">服务全球 接受全国快递</h2>
                    <h4 class="f16">{{$store.state.takeSendCity}}{{$store.state.takeSendNum}}城免费上门取件。</h4>
                </div>
            </div>
            <!--列表-->
            <ul>
                <li v-for="item in list" >
                    <div class="title "  :style="{textAlign:item.align}">
                        <h2>{{item.title}}</h2>
                        <p v-html="item.desc"></p>
                    </div>
                    <img :src="'/images/home/'+item.pic+'.png'" alt="" align="middle">
                </li>
            </ul>

            <div class="mid t_center">
                <h3 class="f24"><img class="icon" src="/images/home/serviceRange_06.png" ><span>顺丰包邮</span></h3>
                <p style=''>{{$store.state.takeSendCity}}</p>

                <!-- <h3 class="f24"><img class="icon" src="/images/home/serviceRange_07.png" ><span>包拯体验店</span></h3>
                <p class="f14">北京市朝阳区青年路88号小悦中心2号楼912</p>
                <p class="f14">杭州·武林银泰百货总店C馆 6F 天猫无忧购服务中心内 </p> -->
            </div>
                                                                           
            <img  src="/images/home/serviceRange_05.png" alt="" align="middle">

        </div>
        <div class="tool-bar f28">
            <div style="width:100%">
                <!-- <div  id="alldo" style="float: left;position:absolute;width:160px;z-index:999;height: 50px;">
                </div> -->
                    
                <!-- <button class="kefu" @click='submit()'><img src="/images/base/wechart-icon.png" class="icon" alt="">问客服</button> -->
                <button class="kefu2" @click='toPublic'><img src="/images/base/wechart-icon.png" class="icon" alt="">问客服</button>
                
                
                <button class="primary pay" @click='submityuyue()'>立即预约</button>
            </div>
        </div>
    </section>
</template>

<script>
    // import wxShare from '@/assets/js/wx.share'
    import wxShare from "@/assets/js/wx.share"
    import { setTimeout } from 'timers';
    import getWXConfig from "@/assets/js/wx.config";
    import zhugeObj from "@/assets/js/track";
    export default {
        name: "index",
        // components:{blackBack},
        data() {
            return {
                height:document.documentElement.clientHeight+'px',
                list:[
                    {title:'方便',desc:'包拯小哥 专人or顺丰上门取件',pic:'serviceRange_02',animation:'fadeInLeft'},
                    {title:'安全',desc:'全链路监控 安全送达<br>一物一码 360°无死角监控',pic:'serviceRange_03',align:'right',animation:'fadeInRight'},
                    {title:'省心',desc:'专业服务运营全程跟进物品情况<br>线上方案随时可查',pic:'serviceRange_04',animation:'fadeInLeft'},
                ],
                botList:[
                    {area:'北京',desc:'北京建外soho合作点、北京望京合作点、北京金融合作点'},
                    {area:'天津',desc:'天津赛维合作点、天津精英跳床合作点、天津红黄蓝亲子乐园合作点、天津卡其卡合作点'},
                    {area:'杭州',desc:'杭州滨江区宝龙城广场合作点'},
                    {area:'武汉',desc:'武汉市区合作点、武汉市江夏区合作点'},
                    {area:'南京',desc:'南京缪斯合作点'},
                    {area:'成都',desc:'成都骊亭合作点、成都宝利汇合作点'},
                ]
            }
        },
        watch: {},
        computed: {},
        created() {
        },
        mounted() {
            zhugeObj.track({
               title: "包邮地址页-曝光"
            });
            setTimeout(()=>{
                let shareBody = {
                    desc : '全国11个城市上门取件',
                    title : '服务全球的奢护品牌包拯，来到家门口啦！',
                }; 
                wxShare(shareBody);
            },1000)
            getWXConfig({path:'http://mi.baozheng.cc'})

            // 屏蔽微信客服
            // var dom = document.getElementById('alldo')
            // let urlend = encodeURIComponent(window.location.href)
            // dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?h5Url=我正在浏览快递说明：'+urlend+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:160px;height:45px;"></div></template></wx-open-launch-weapp>'
        
            // var launchBtn = document.getElementById('launch-btn')
            // if (!launchBtn) {
            // return
            // }
            // launchBtn.addEventListener('launch', function (e) {
            //     zhugeObj.track({
            //             title: "包邮地址页-问客服按钮-点击"
            //         });
            //     })
            // launchBtn.addEventListener('error', function (e) {
            // console.log('fail', e.detail)
            // })
        },
        methods: {
            toPublic() {
                window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwNjUzNzQyNA==&scene=124#wechat_redirect'
            },
            submityuyue(){
                zhugeObj.track({
                    title: "包邮地址页-直接寄包按钮-点击"
                });
                this.$router.push({
                    name: "quick"
                }); 
            }
        }

    }
</script>

<style scoped lang="scss">
.serviceRange{
    /*背景*/
    .backWrap{
        width: 100%;
        // background: url("/images/home/serviceRange_08.png") no-repeat 92% 95%;
        background-size: 140px;
        >img{width:100%;}
        .inner{
            padding:  80px 30px 0;
            img{width: 400px}
            h2{padding: 40px 0 40px;line-height: 50px;font-size:50px;}
            h4{color: #4a4a4a;line-height:50px;font-size: 35px}
        }
    }
    .scrollWrap{
        position: fixed;left: 0;top:0;overflow: auto;box-sizing: border-box;
        ul{
            background: #fff;
            .title{
                padding: 60px 20px 20px;
                /*opacity: 0;*/
                h2,p{font-weight: bold}
                h2{font-size: 70px;line-height: 130px}
                p{font-size: 40px;line-height: 50px;color:#656565}
            }
            img{width:100%;}
        }

        .mid{
            background: #fff;padding: 100px 30px 50px;
            h3{
                margin-bottom: 40px;
                .icon,span{vertical-align: middle;}
                .icon{width:80px;margin-right:30px;}
                span{display: inline-block;line-height: 80px;font-weight: bold;font-size: 50px}
            }
            p{
                line-height: 40px;margin-bottom: 50px;
                font-size: 25px;
                &:nth-of-type(2){margin-bottom: 0;}
            }
        }
        >img{width: 100%}

        .bot{
            padding: .53rem .2rem;background: #fff;
            h2{line-height: .42rem;margin-bottom: .3rem}
            li{line-height: .26rem;margin-bottom: .26rem}
        }
    }
}
.tool-bar{
      position: fixed;
      width: 100%;
      display: flex;
      z-index: 9;
      align-items: center;
      height: 108px;
      bottom: 0px;
      left: 0;
      background:rgba(255,255,255,1);
      box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
      justify-content: flex-end;
    
      .pay{
          width: 44.2666%;
          height: 84px;
      }
    }
    .kefu,.kefu2{
        width: 44.2666%;
        height: 84px;
        font-size: 30px;
        position: relative;
        top: -2px;
        font-weight: 900;
        margin-left:3.8%;
        margin-right:3.8%;
        box-shadow: 0px 0px 8px 0px rgba(0, 217, 103, 0.1);
        border-radius: 46px;
        border: 2px solid #333333;
        .icon{
            display: inline-block;vertical-align: middle;width: 40px;height: 40px;margin: 10px;
        }
    }

</style>
